import { render, staticRenderFns } from "./yk.vue?vue&type=template&id=e4c2a00c&scoped=true"
import script from "./yk.vue?vue&type=script&lang=js"
export * from "./yk.vue?vue&type=script&lang=js"
import style0 from "./yk.vue?vue&type=style&index=0&id=e4c2a00c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c2a00c",
  null
  
)

export default component.exports